import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'

createRoot(document.getElementById('root')!).render(<App />)

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistration('/sw.js')
    .then(reg => reg?.unregister())
    .catch(() => {})
}
